export const videoHeader = [
    { id: 1, title: "Matches", value: "match", is_showable: true , keep_header :true},
    { id: 6, title: "Daywise Streaming", value: "OTHERS", is_showable: false , keep_header :true},
    { id: 2, title: "Interviews", value: "INTERVIEW", is_showable: false , keep_header :false},
    { id: 3, title: "Opening Ceremony", value: "OPENINGCEREMONY", is_showable: false, keep_header :false},
    { id: 4, title: "Draws", value: "CLOSINGCEREMONY", is_showable: false , keep_header :true},
    { id: 5, title: "Award Ceremony", value: "AWARDCEREMONY", is_showable: false , keep_header :false},
    { id: 7, title: "Broadcast", value: "BROADCAST", is_showable: false , keep_header :true},
]
